exports.JUNIOR_AGE = 14;